export const criarConfigBuscaProdutor = (idOrganizacao) => ({
  label: 'Produtor',
  placeholder: 'Nome ou CNPJ...',
  titulo: 'Buscar Produtor',
  endpointApi: 'Parceiros',
  idField: 'idParceiro',
  displayField: 'nomeFantasia',
  descField: 'nomeFantasia',
  camposFiltro: [
    { label: 'Nome Fantasia', model: 'busca', tipo: 'text' },
    {
      label: 'Categoria',
      model: 'lstCategoria',
      tipo: 'select',
      optionsEndpoint: 'ListasCliente/lookup/PCAT'
    }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idParceiro', width: '10%' },
    { header: 'Nome Fantasia', dataField: 'nomeFantasia', width: '30%' },
    { header: 'Razão Social', dataField: 'razaoSocial', width: '30%' },
    { header: 'Documento', dataField: 'documento', width: '20%' }
  ],
  filtrosFixos: {
    idOrganizacao,
    isFornecedor: true
  }
})
